import React, { FC } from "react";

import { useModalAnimation } from "@/hooks/useModalAnimation";

import * as S from "./styles";

type TUnauthorizedUserSignUp = {
  open: boolean;
  handleClose: () => void;
  handleLogin: () => void;
  handleSignUp: () => void;
};

const ICON_COLOR = "#9cd3fd";

export const UnauthorizedUserDialog: FC<TUnauthorizedUserSignUp> = ({
  open,
  handleClose,
  handleLogin,
  handleSignUp,
}) => {
  const { mounted, closing } = useModalAnimation(open);

  if (!mounted) return null;

  return (
    <S.Overlay $open={!closing}>
      <S.ModalContainer $closing={closing} onClick={(e) => e.stopPropagation()}>
        <S.CloseButton onClick={handleClose} aria-label="Close">
          &#x2715;
        </S.CloseButton>

        <S.Title>Sign Up to Continue</S.Title>
        <S.Subtitle>Create your free account in seconds.</S.Subtitle>

        <S.AdvantagesGrid>
          {/* Free Downloads */}
          <S.AdvantageCard>
            <S.AdvantageIcon>
              <svg viewBox="0 0 24 24" fill="none" stroke={ICON_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
            </S.AdvantageIcon>
            <S.AdvantageTitle>Free Downloads</S.AdvantageTitle>
            <S.AdvantageDesc>Download free tracks for your YouTube videos</S.AdvantageDesc>
          </S.AdvantageCard>

          {/* Claim Resolution */}
          <S.AdvantageCard>
            <S.AdvantageIcon>
              <svg viewBox="0 0 24 24" fill="none" stroke={ICON_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="4" />
                <polygon points="10,8.5 16,12 10,15.5" fill={ICON_COLOR} stroke="none" />
              </svg>
            </S.AdvantageIcon>
            <S.AdvantageTitle>Claim Resolution</S.AdvantageTitle>
            <S.AdvantageDesc>Submit videos to get copyright claims removed</S.AdvantageDesc>
          </S.AdvantageCard>

          {/* Favorites Library */}
          <S.AdvantageCard>
            <S.AdvantageIcon>
              <svg viewBox="0 0 24 24" fill="none" stroke={ICON_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </S.AdvantageIcon>
            <S.AdvantageTitle>Favorites Library</S.AdvantageTitle>
            <S.AdvantageDesc>Save your top picks for easy access later</S.AdvantageDesc>
          </S.AdvantageCard>

          {/* New Releases */}
          <S.AdvantageCard>
            <S.AdvantageIcon>
              <svg viewBox="0 0 24 24" fill="none" stroke={ICON_COLOR} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
                <path d="M13.73 21a2 2 0 0 1-3.46 0" />
              </svg>
            </S.AdvantageIcon>
            <S.AdvantageTitle>New Releases</S.AdvantageTitle>
            <S.AdvantageDesc>Get notified when new free music is released</S.AdvantageDesc>
          </S.AdvantageCard>
        </S.AdvantagesGrid>

        <S.PrimaryButton onClick={handleSignUp}>
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#60a3d7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ display: "inline-block", verticalAlign: "middle", marginRight: "8px", marginTop: "-2px" }}>
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <line x1="19" y1="8" x2="19" y2="14" />
            <line x1="22" y1="11" x2="16" y2="11" />
          </svg>
          Create Free Account
        </S.PrimaryButton>

        <S.LoginLink>
          Already have an account?{" "}
          <button onClick={handleLogin}>Login</button>
        </S.LoginLink>
      </S.ModalContainer>
    </S.Overlay>
  );
};
